import { api } from './client';

export interface UnitOfMeasure {
  id: string;
  code: string;
  symbol: string;
  name: string;
  nationalCode: string | null;
  isActive: boolean;
}

export interface VatRate {
  id: string;
  code: string;
  rate: string | null;
  name: string;
  isCalculated: boolean;
  validFrom: string;
  validTo: string | null;
  sortOrder: number;
  isActive: boolean;
}

export const unitsOfMeasureApi = {
  list: () => api.get<{ items: UnitOfMeasure[] }>('/units-of-measure'),
};

export const vatRatesApi = {
  list: () => api.get<{ items: VatRate[] }>('/vat-rates'),
};
